import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import * as Auth from "api/Auth";
import { getAuthToken, setLoginInfo } from "helpers/authstorage";
import { appStore } from "models";
import { appInitGetUserInfo } from "models/actions";
import { get } from "lodash-es";
import CircularProgress from "@material-ui/core/CircularProgress";
import Box from "@material-ui/core/Box";

const TokenLogin = () => {
  const history = useHistory();

  useEffect(() => {
    const token = getAuthToken();
    if (!token) {
      history.replace("/login");
      return;
    }

    Auth.authenticateWithToken(token)
      .then(({ data }) => {
        if (data && data.authId) {
          setLoginInfo(data);
          sessionStorage.setItem("tokenAuth", String(true));
          appStore.setCurrentUser(data, true);
          appInitGetUserInfo(get(data, "id"), false);
          history.replace("/subscription?upgrade=true");
        } else {
          history.replace("/login");
        }
      })
      .catch(() => {
        history.replace("/login");
      });
  }, [history]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <CircularProgress />
    </Box>
  );
};

export default TokenLogin;
